var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-market-entry" }, [
    _c(
      "div",
      { staticClass: "viq-market-entry__header" },
      [
        _c("h3", { staticClass: "viq-market-entry__title" }, [
          _vm._v("Market Entry Assessment"),
        ]),
        _vm._v(" "),
        _vm.step === "form"
          ? _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.goBack } },
              [_vm._v("Back")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.step === "form"
      ? _c("div", { staticClass: "viq-market-entry__form" }, [
          _c("p", { staticClass: "viq-market-entry__desc" }, [
            _vm._v(
              "\n      Get a comprehensive regulatory landscape assessment for entering a new jurisdiction.\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-market-entry__field" },
            [
              _c("label", [_vm._v("Target Jurisdiction")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  placeholder: "e.g., Germany, United Kingdom, Singapore...",
                },
                model: {
                  value: _vm.jurisdiction,
                  callback: function ($$v) {
                    _vm.jurisdiction = $$v
                  },
                  expression: "jurisdiction",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-market-entry__field" },
            [
              _c("label", [_vm._v("Business Type")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  placeholder: "e.g., Payment institution, E-money provider...",
                },
                model: {
                  value: _vm.businessType,
                  callback: function ($$v) {
                    _vm.businessType = $$v
                  },
                  expression: "businessType",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "viq-market-entry__field" }, [
            _c("label", [_vm._v("Assessment Depth")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "viq-market-entry__levels" },
              _vm._l(_vm.levels, function (level) {
                return _c(
                  "div",
                  {
                    key: level.id,
                    staticClass: "viq-market-entry__level",
                    class: {
                      "viq-market-entry__level--active":
                        _vm.selectedLevel === level.id,
                    },
                    on: {
                      click: function ($event) {
                        _vm.selectedLevel = level.id
                      },
                    },
                  },
                  [
                    _c("h4", [_vm._v(_vm._s(level.title))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(level.description))]),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-market-entry__form-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.canSubmit },
                  on: { click: _vm.generate },
                },
                [_vm._v("\n        Generate Assessment\n      ")]
              ),
            ],
            1
          ),
        ])
      : _vm.step === "results"
      ? _c("div", { staticClass: "viq-market-entry__results" }, [
          _vm.isStreaming
            ? _c("div", { staticClass: "viq-market-entry__streaming" }, [
                _c("span", { staticClass: "viq-market-entry__spinner" }),
                _vm._v("\n      Generating market entry assessment...\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.streamingText || _vm.reportContent
            ? _c("div", {
                staticClass: "viq-market-entry__content",
                domProps: { innerHTML: _vm._s(_vm.renderedContent) },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isStreaming
            ? _c(
                "div",
                { staticClass: "viq-market-entry__actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("export-pdf")
                        },
                      },
                    },
                    [_vm._v("Export as PDF")]
                  ),
                  _vm._v(" "),
                  _vm.$config.features && _vm.$config.features.viqShare
                    ? _c("el-button", { on: { click: _vm.share } }, [
                        _vm._v("Save & Share"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("New Assessment"),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }